import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import CircleBG1 from '../assets/images/Circle BG 1.png';
import '../components/GlobalStyle.css';
import { FadeLoad, FadeScroll } from '../components/styled/Motion.styled';
import { BPSArrowLink, BPSPrimaryButton, BPSSecondaryButton, BPSTextLink } from '../components/styled/Buttons';



const CardOrdering = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Products & Services | Card Ordering</title>
                <link rel="canonical" href="https://bestpayment.solutions/card-ordering" />
            </Helmet>
            <Navigation />
            <Container fluid>
                <FadeLoad>
                    <Row className='align-items-center justify-content-evenly vh-75'>
                        <Col lg={5}>
                            coming soon
                        </Col>
                    </Row>
                </FadeLoad>
            </Container >
            <Footer />
        </>
    );
}

export default CardOrdering;